import React from 'react';
import type { ComponentProps, ReactElement } from 'react';

import type { LayoutSection as OriginalLayoutSection } from '@atlaskit/renderer/nodes';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/editor-experiment';

import type { LightNodeProps } from '../LightNodeObserver.ts';

/** One observed boundary for all columns; preserve Platform's standard and advanced layout DOM. */
export const LayoutSection = ({
	children,
	localId,
	lightNodeRef,
}: ComponentProps<typeof OriginalLayoutSection> & LightNodeProps): ReactElement =>
	editorExperiment('advanced_layouts', true) ? (
		<div
			ref={lightNodeRef}
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Preserve Platform's advanced layout container styles.
			className="layout-section-container"
			data-local-id={localId}
		>
			<div data-layout-section data-layout-columns={React.Children.count(children)}>
				{children}
			</div>
		</div>
	) : (
		<div ref={lightNodeRef} data-layout-section data-local-id={localId}>
			{children}
		</div>
	);
